module.exports = "/images/forklift-training-list-thumb.png?3b5b99e4dff0b679be70345b413f2ed6";